import React, { useState } from 'react'
import { Spin } from 'antd';
import DashboardTable from '../dashboardComponents/DashboardTable';

import '../../css/reviewform.css'
import '../../css/dashboard.css'

const Dashboard = () => {

  const [isLoading, setIsLoading] = useState(false);


  return (
     <Spin spinning={isLoading}>
      {/* <Header /> */}
      {/* <h4 className='text-center text-xl font-bold' style={{marginTop:'20px'}}>There will be SAP downtime from 12/28/2025 7am EST to 12/29/2025 8 am EST. Business Users are requested to refrain from approving any request or creating any new request during this time.</h4> */}
      <div className='dashboard-cnt'>

        <DashboardTable 
          setIsLoading={setIsLoading}
        />
      </div>

    </Spin>
  )
}

export default Dashboard